<template>
  <d-row class="my-4">
    <d-col cols="12">
      <d-card>
        <d-card-header
          v-d-toggle.payment-processor-settings-collapse
          class="cursor-pointer"
        >
          <i
            class="material-icons mr-1 animate"
            :class="{ 'rotate-90': !collapsed }"
            >chevron_right</i
          >
          Payment Processor
        </d-card-header>
        <d-collapse
          id="payment-processor-settings-collapse"
          @hide="collapsed = true"
          @show="collapsed = false"
        >
          <d-card-body class="card-body-border">
            <d-row v-if="!!settings.id">
              <d-col cols="12">
                <p>
                  Use this link to open up your Stripe dashboard. This link is
                  opened in a new window. Some browsers will detect this as a
                  popup, so you may need to click a second time to open this
                  link up in a new tab
                </p>
                <d-button link @click="getStripeDashboardLink"
                  >Open Stripe Dashboard</d-button
                >
                <small v-if="!!stripeURL" class="d-block">
                  <a :href="stripeURL" class="btn btn-link btn-sm text-info">
                    (Click here if your browser blocks popups)
                  </a>
                </small>
              </d-col>
            </d-row>
          </d-card-body>
        </d-collapse>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import { keepKeys } from "@/helpers";
import moment from "moment";

const DEFAULT_PAYMENT_PROCESSOR_MODEL = {
  description: null,
  payment_descriptor: null,
  ping_on_payment: null,
};

const PAYMENT_PROCESSOR_SCHEMA = {
  fields: [
    {
      type: "input",
      inputType: "text",
      label: "Statement Descriptor",
      hint: "",
      model: "statement_descriptor",
      placeholder: "",
      required: true
    },
        {
      type: "input",
      inputType: "text",
      label: "Description",
      hint: "",
      model: "description",
      placeholder: "",
      required: true
    },
        {
      type: "input",
      inputType: "text",
      label: "Ping on Payment",
      hint: "",
      model: "ping_on_payment",
      placeholder: "",
      required: true
    },
  ]
};

const PAYMENT_PROCESSOR_OPTIONS = {
  validateAfterLoad: false,
  validateAfterChanged: true,
  validateAsync: true
};

export default {
  data() {
    return {
      collapsed: true
    };
  },
  created() {
    this.model = tthis.$store.state.settings.paymentProcessor;
  },
  methods: {
    getStripeDashboardLink() {
      this.$store.dispatch("settings/getStripeDashboardLink").then(data => {
        window.open(data.url, "_blank");
        this.stripeURL = data.url;
      });
    }
  }
};
</script>

<style></style>
